import React from "react";
import {
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
} from "@material-ui/core";
import { TransitionProps } from "@material-ui/core/transitions";

type Props = {
  isCustomValidate?: boolean;
  isOpen: boolean;
  handleClose: any;
  handleConfirm?: any;
  children?: any;
  heading?: string;
  headerColor?: string;
  confirmButton?: string;
  cancelButton?: string;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | undefined;
};
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />;
});
export default function TransitionDialog({
  isOpen,
  handleClose,
  handleConfirm,
  children,
  heading,
  headerColor = "",
  isCustomValidate = false,
  confirmButton = "Yes",
  cancelButton = "No",
  maxWidth,
}: Props): React.ReactElement {
  return (
    <>
      <Dialog
        style={{ borderRadius: 1 }}
        open={isOpen}
        onClose={handleClose}
        TransitionComponent={Transition}
        keepMounted
        maxWidth={maxWidth}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <Typography>
          <DialogTitle
            id="alert-dialog-slide-title"
            style={{ color: headerColor ? headerColor : "inherit" }}
          >
            {heading}
          </DialogTitle>
        </Typography>
        <DialogContent style={{ fontSize: 16 }}>{children}</DialogContent>
        <DialogActions style={{ marginRight: 10, marginBottom: 5 }}>
          {isCustomValidate ? (
            <Button onClick={handleClose} variant="contained">
              Close
            </Button>
          ) : (
            <>
              <Button onClick={handleClose} variant="contained">
                {cancelButton}
              </Button>

              <Button onClick={handleConfirm} variant="contained" color="secondary">
                {confirmButton}
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}
